var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['cf-c-icon-wrap cf-c-icon', _vm.className, _vm.wrapperClasses],on:{"click":function($event){return _vm.$emit('click', $event)}}},[(_vm.isPng)?_c('img',{class:['cf-c-icon', _vm.className],attrs:{"src":require(`@/assets/icons/temporary-icon-folder/${_vm.icon}`)}}):_c(_vm.iconName,{tag:"component",class:[_vm.className]})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }